<template>
  <div style="height:100vh">
    <div id="login" v-if="showLogin">
      <h1>Sin conexión</h1>
      <a class="item" :href="env === 'production' ? '/#main' : 'http://localhost/#main' ">{{ $t("components.navbar.Volver") + appParentName}}</a>
    </div>
  </div>
</template>

<script>

import { Config } from '../config';

export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      showLogin: false,
      env: process.env.NODE_ENV,
      appParentName: Config.parentAppName
    };
  },
  mounted: function () {
    setTimeout(() => {
      this.showLogin = true;
    }, 3000);
  },
  methods: {

  }
};
</script>

<style scoped>
#login {
  width: 500px;
  border: 1px solid #cccccc;
  background: white;
  margin: auto;
  margin-top: 30%;
  padding: 20px;
}
</style>
